import React from 'react';

const Concepts = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Concepts Library</h1>
      <p className="text-gray-600">Concepts management coming soon...</p>
    </div>
  );
};

export default Concepts;